import sharedMutations from "@/store/utils/shared-mutations";
import { Notification } from "@/models"

const UPDATE_NOTIFICATION_LIST = (state, params) => {
    let newNotification = state.notifications.find(item => item.id === params._id)
    state.systemNotiMeta = { ...state.systemNotiMeta, unReadNotifications: state.systemNotiMeta.unReadNotifications + 1 }
    state.notifications = newNotification ? state.notifications : [ new Notification(params), ...state.notifications ]
  }

const UPDATE_NOTIFICATION_LIST_UPGRADE = (state, params) => {
  let newNotification = state.upgradeNotifications.find(item => item.id === params.id)
  state.upgradeNotiMeta = { ...state.upgradeNotiMeta, unReadNotifications: state.upgradeNotiMeta.unReadNotifications - 1 }
  state.upgradeNotifications.splice(
    state.upgradeNotifications.indexOf(newNotification),
    1,
    new Notification({ ...newNotification, isRead: true })
  );
}

const NOTIFICATION_READ = (state, params) => {
  let newNotification = state.notifications.find(item => item.id === params.id)
  state.systemNotiMeta = { ...state.systemNotiMeta, unReadNotifications: state.systemNotiMeta.unReadNotifications - 1 }
  state.notifications.splice(
    state.notifications.indexOf(newNotification),
    1,
    new Notification({ ...newNotification, isRead: true })
  );
}
export default {
  ...sharedMutations,
  UPDATE_NOTIFICATION_LIST,
  NOTIFICATION_READ,
  UPDATE_NOTIFICATION_LIST_UPGRADE
};
